// CRO-022 (B16) : « Voir plus de produits » ajoute la page suivante sous la grille, sans recharger.
// Au retour depuis une fiche produit, les pages déjà vues sont rechargées et la position est retrouvée.
(function () {
  var KEY = 'bz-load-more';
  function grid() { return document.getElementById('product-grid'); }

  // Clé de la liste : chemin + tri et filtres, sans les paramètres de suivi (_su_rec, utm_, fbclid…)
  function listKey() {
    var params = new URLSearchParams(location.search), kept = [];
    params.forEach(function (v, k) {
      if (k === 'sort_by' || k === 'q' || k.indexOf('filter.') === 0) kept.push(k + '=' + v);
    });
    return location.pathname + '?' + kept.sort().join('&');
  }
  function isBackNavigation() {
    var nav = performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
    return nav ? nav.type === 'back_forward' : true;
  }

  function fetchPage(url, sectionId) {
    var u = new URL(url, window.location.origin);
    u.searchParams.set('section_id', sectionId);
    return fetch(u.toString()).then(function (r) { return r.text(); }).then(function (html) {
      return new DOMParser().parseFromString(html, 'text/html');
    });
  }

  function appendFrom(doc) {
    var g = grid(), box = document.querySelector('[data-load-more]');
    if (!g || !box) return null;
    var items = doc.querySelectorAll('#product-grid > li');
    items.forEach(function (li) { g.appendChild(document.importNode(li, true)); });
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(g);
    var next = doc.querySelector('[data-load-more]');
    if (next) {
      next = document.importNode(next, true);
      // le lien « Revenir au début » ne sert que si la liste affichée ne commence pas à la page 1
      var first = next.querySelector('.load-more__first');
      if (first && box.dataset.startPage === '1') first.remove();
      next.dataset.startPage = box.dataset.startPage;
      box.replaceWith(next);
    }
    return items.length;
  }

  // page de départ de la liste affichée (1 si on est arrivé en haut de la liste)
  function markStart() { var box = document.querySelector('[data-load-more]'); if (box && !box.dataset.startPage) box.dataset.startPage = box.dataset.page; }
  document.addEventListener('DOMContentLoaded', markStart);
  markStart();

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-load-more-button]');
    if (!btn) return;
    var box = btn.closest('[data-load-more]');
    if (!box || !grid() || !window.fetch) return; // sans support : lien normal vers la page suivante
    markStart();
    e.preventDefault();
    if (btn.getAttribute('aria-busy') === 'true') return;
    btn.setAttribute('aria-busy', 'true');
    btn.textContent = btn.dataset.loadingText;
    fetchPage(btn.href, box.dataset.sectionId).then(function (doc) {
      if (!appendFrom(doc)) { window.location.href = btn.href; }
    }).catch(function () { window.location.href = btn.href; });
  });

  // Mémoriser les pages chargées avant d'ouvrir une fiche produit
  document.addEventListener('click', function (e) {
    var a = e.target.closest('#product-grid a[href*="/products/"]');
    if (!a) return;
    var box = document.querySelector('[data-load-more]');
    var page = box ? parseInt(box.dataset.page, 10) : 1;
    if (page > 1) {
      try { sessionStorage.setItem(KEY, JSON.stringify({ path: listKey(), page: page, y: window.scrollY, t: Date.now() })); } catch (err) {}
    }
  }, true);

  // Retour sur la liste : recharger les pages déjà vues puis revenir au même endroit
  function restore() {
    var saved; try { saved = JSON.parse(sessionStorage.getItem(KEY) || 'null'); sessionStorage.removeItem(KEY); } catch (err) { return; }
    // seulement au retour arrière, sur la même liste, dans les 30 minutes
    if (!saved || saved.path !== listKey() || !isBackNavigation() || Date.now() - (saved.t || 0) > 30 * 60 * 1000) return;
    var box = document.querySelector('[data-load-more]');
    if (!box || !grid() || parseInt(box.dataset.page, 10) !== 1) return;
    var sectionId = box.dataset.sectionId, p = 2;
    (function step() {
      var b = document.querySelector('[data-load-more-button]');
      if (p > saved.page || !b) { window.scrollTo(0, saved.y); return; }
      fetchPage(b.href, sectionId).then(function (doc) { appendFrom(doc); p++; step(); }).catch(function () { window.scrollTo(0, saved.y); });
    })();
  }
  window.addEventListener('pageshow', function (e) { if (!e.persisted) restore(); });
})();
